import React from 'react';
import { PaymentMethod } from '../../../../models';
import PaymentStepLayout from '../PaymentStepLayout';
import PaymentMethodOption from './PaymentMethodOption';

interface PaymentMethodStepProps {
  paymentMethods: PaymentMethod[];
  setStepSelected: React.Dispatch<React.SetStateAction<number>>;
  stepSelected: number;
  paymentMethodSelected: PaymentMethod;
  setPaymentMethodSelected: React.Dispatch<React.SetStateAction<PaymentMethod>>;
}

function PaymentMethodStep({
  setStepSelected,
  stepSelected,
  paymentMethods,
  paymentMethodSelected,
  setPaymentMethodSelected,
}: PaymentMethodStepProps) {
  const onCheck = (e: React.ChangeEvent<HTMLInputElement>) => {
    const paymentMethod = paymentMethods.find(
      (item) => item._id === e.target.dataset.id
    );
    setPaymentMethodSelected(paymentMethod);
  };

  return (
    <PaymentStepLayout
      title="Método de pago"
      num={1}
      collapsed={stepSelected === 1}
      setStepSelected={setStepSelected}
      paymentMethod={paymentMethodSelected}
    >
      <div className="my-3 mt-5 pl-2 flex flex-col gap-5">
        {paymentMethods?.map((item) => (
          <PaymentMethodOption
            key={item._id}
            paymentMethod={item}
            checked={item?._id === paymentMethodSelected?._id}
            onChange={onCheck}
          />
        ))}
      </div>
    </PaymentStepLayout>
  );
}

export default PaymentMethodStep;
